<template>
    <div class="making-our-brand-tangible-arcase" :data-shape-id="shapeId" ref="sectionWrapper">
        <div class="wrapper wrapper-medium">
            <div class="section-copy">
                <div class="overline">Making Our Brand Tangible</div>
                <h2 class="major-heading">Augmented Reality</h2>
                <p>
                    Brands need to continuously reinvent themselves in order to stay relevant to their customers.
                    Leveraging new touchpoints and technologies like Augmented and Virtual Reality is just one way of
                    achieving this.
                </p>
            </div>
            <div class="button-container" v-show="!isArPlaying">
                <button-icon icon="plus2" text="How to start" @click.native="toggleVideo" hasText />
            </div>
            <div class="section-visual">
                <img class="key-visual" :src="getShadow()" />
                <img class="phone" :src="getPhone()" />
            </div>
        </div>
    </div>
</template>

<script>
    import ButtonIcon from '../../patterns/buttons/ButtonIcon.vue';

    export default {
        name: 'MakingOurBrandTangibleArcase',
        data() {
            return {
                includeIframe: true,
                isArPlaying: false,
            };
        },
        components: { ButtonIcon },
        props: ['headline', 'copy', 'shapeId', 'vimeoId', 'buttonIcon', 'sectionName'],
        computed: {
            cookieSettings() {
                return this.$store.getters.cookieSettings;
            },
        },
        methods: {
            getPhone() {
                return require('../../../assets/png/poster_element_wo_shadow.png');
            },
            getShadow() {
                return require('../../../assets/png/poster_element_shadow.png');
            },
            getImgUrl() {
                return require('../../../assets/png/poster_element_shadow.png');
            },
            toggleVideo() {
                this.$store.dispatch('toggleArModal');
            },
        },
    };
</script>

<style lang="scss" scoped>
    @keyframes anim-float {
        0% {
            transform: translateY(0px);
        }

        50% {
            transform: translateY(-10px);
        }

        100% {
            transform: translateY(0px);
        }
    }
    @keyframes anim-float-shadow {
        0% {
            opacity: 1;
            transform: translateX(0px) scaleX(1);
        }

        50% {
            opacity: 0.75;
            transform: translateX(-10px) scaleX(1.5);
        }

        100% {
            opacity: 1;
            transform: translateX(0px) scaleX(1);
        }
    }

    .making-our-brand-tangible-arcase {
        &.active {
            .section-copy {
                animation: anim-fade-in 1s 0.7s forwards;
            }

            .section-visual {
                animation: anim-fade-in-from-bottom 1s 0.9s forwards;
            }
            .button-container {
                animation: anim-fade-in-from-bottom 1s 1.2s forwards;
            }
        }

        &.on-leave {
            .section-copy,
            .section-visual,
            .button-container {
                animation: anim-fade-out 0.3s forwards;
            }
        }

        .wrapper {
            @include flex($align-items: center);
            @media (max-width: breakpoint('medium')) {
                text-align: center;
            }
        }

        .section-copy {
            width: 50%;
            @include border-box();
            z-index: 1;
            position: relative;
            opacity: 0;
            box-sizing: border-box;
            padding-right: 50px;

            @media (max-width: breakpoint('medium')) {
                width: 100%;
                text-align: center;
                padding-right: 0px;
            }
        }

        @media (max-width: breakpoint('extra-small')) {
            margin-top: spacing(10);
        }
    }
    .button-container {
        opacity: 0;
        //position: absolute;
        //bottom: 0;
        //transform: translateY(50%);
        //margin-left: 15%;
        //text-align: center;
        margin-top: -10px;
        width: 40%;
        z-index: 1000000;
        order: 2;
        @media (max-width: breakpoint('medium')) {
            width: 100%;
            order: 1000;
            margin-top: 10px;
        }
    }

    .section-visual {
        width: 50%;
        opacity: 0;
        position: relative;
        .key-visual {
            width: 100%;
            filter: blur(2px);
            @media (max-width: breakpoint('medium')) {
                width: 40%;
            }
            animation: anim-float-shadow 12s infinite linear;
        }
        .phone {
            position: absolute;
            top: 0px;
            left: 0px;
            width: 100%;
            @media (max-width: breakpoint('medium')) {
                width: 40%;
                left: 50%;
                margin-left: -20%;
            }
            animation: anim-float 12s infinite linear;
        }
        @media (max-width: breakpoint('medium')) {
            width: 100%;
            text-align: center;
        }

        .image-wrapper {
            position: relative;
            width: 150%;
            height: auto;
            display: block;
            //box-shadow: box-shadow('big');

            @media (max-width: breakpoint('extra-large') + 300) {
                width: 125%;
            }

            @media (max-width: breakpoint('extra-large')) {
                width: 100%;
            }

            .cookie-consent {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background: rgba(0, 0, 0, 0.75);
                color: #ffffff;
                padding: 0 40px;
                box-sizing: border-box;
                opacity: 0;
                pointer-events: none;
                transition: opacity 0.3s;

                &.is-visible {
                    opacity: 1;
                    pointer-events: all;
                }

                @media (max-width: breakpoint('small')) {
                    padding: 0 20px;
                }

                .cookie-consent-message {
                    position: relative;
                    top: 50%;
                    transform: translateY(-50%);
                    text-align: center;
                }

                a {
                    color: color('magenta');
                    font-weight: font-weight(bold);
                    text-underline-position: under;
                }
            }
        }
    }

    @media (max-width: breakpoint('extra-small')) {
        .overline {
            display: none;

            & + .major-heading {
                margin-top: 0;
            }
        }
    }

    /* TODO globalize and bundle all keyframe anim in global SCSS */

    @keyframes anim-fade-in {
        from {
            transform: translateX(-20px);
            opacity: 0;
        }

        to {
            transform: translateX(0px);
            opacity: 1;
        }
    }

    @keyframes anim-fade-in-from-bottom {
        from {
            transform: translateY(20px);
            opacity: 0;
        }

        to {
            transform: translateY(0px);
            opacity: 1;
        }
    }

    @keyframes anim-fade-out {
        from {
            transform: translateY(0px);
            opacity: 1;
        }

        to {
            transform: translateY(20px);
            opacity: 0;
        }
    }

    @keyframes anim-fade-out-to-bottom {
        from {
            transform: translateY(0px);
            opacity: 1;
        }

        to {
            transform: translateY(20px);
            opacity: 0;
        }
    }
</style>
